import { render, staticRenderFns } from "./ClinicalNotesItemRightBar.vue?vue&type=template&id=e25b5f98&"
import script from "./ClinicalNotesItemRightBar.vue?vue&type=script&lang=js&"
export * from "./ClinicalNotesItemRightBar.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalNotesItemRightBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports